import axios from 'axios';

const getMatches = async ({ query, numResults, minPercentage, session, sinceDate }) => {
  console.log(
    `query: ${query}, numResults: ${numResults}, minPercentage: ${minPercentage}, session: ${session}, sinceDate: ${sinceDate}`
  );
  const queryString = `query=${encodeURIComponent(
    query
  )}&numResults=${numResults}&minPercentage=${minPercentage}&session=${session}&sinceDate=${sinceDate}`;
  console.log(`/api/bills?${queryString}`);
  const response = await axios.get(`/api/bills?${queryString}`);
  return response.data;
};

const getSections = async ({ billId, session, version }) => {
  const response = await axios.get(`/api/bills/${billId}/${session}/${version}`);
  return response.data;
};

const getVersions = async ({ billId, selectedSession }) => {
  console.log(`billId: ${billId}, selectedSession: ${selectedSession}`);
  const response = await axios.get(`/api/bills/versions/${billId}/${selectedSession}`);

  return response.data;
};

const getComparison = async ({ billId, session, versions }) => {
  // Assuming your API expects a POST request with a JSON body
  const url = `/api/bills/comparisons`;
  const response = await axios.post(url, {
    billId,
    session,
    versions, // This sends the versions array directly
  });
  return response.data;
};

const getQueryResponse = async ({ auth, query, billText, billId, session, mode, version, modelType }) => {
  const response = await axios.post(`/api/bills/query`, {
    auth,
    query,
    billText,
    billId,
    session,
    mode,
    version,
    modelType,
  });
  return response.data;
};

const getCompanies = async () => {
  // Assuming your API expects a POST request with a JSON body
  const url = `/api/bills/companies`;
  const response = await axios.get(url);
  return response.data;
};

const compileReport = async ({
  company,
  billNumber,
  version,
  companyInfo,
  selectedSections,
  state,
  selectedSession,
}) => {
  const response = await axios.post(`/api/bills/compileReport`, {
    company,
    billNumber,
    version,
    companyInfo,
    selectedSections,
    state,
    selectedSession,
  });
  console.log(response.data);
  return response.data;
};

const clearQuery = async ({ auth, mode }) => {
  const response = await axios.post(`/api/bills/clear-cache`, {
    auth,
    mode,
  });
  return response.data;
};

const getCompanyInfo = async (companyID) => {
  console.log(companyID);
  const response = await axios.get(`/api/bills/companyInfo/${companyID}`);
  return response.data;
};

const getPredictedVotes = async ({ billId, session, version }) => {
  const response = await axios.get(`/api/bills/predictedVotes/${billId}/${session}`, {
    params: { version },
  });
  return response.data;
};

const getMemberPredictedVote = async ({ billId, session, version, memnum }) => {
  const response = await axios.get(`/api/bills/predictedVotes/${billId}/${session}/${memnum}`, {
    params: { version },
  });
  return response.data;
};

const billService = {
  getMatches,
  getSections,
  getQueryResponse,
  getVersions,
  clearQuery,
  getComparison,
  getCompanies,
  compileReport,
  getCompanyInfo,
  getPredictedVotes,
  getMemberPredictedVote,
};

export default billService;
